<template>
  <div class="trainee-list-modal-overlay" @click="closeModalOutside">
    <div class="trainee-list-modal" @click.stop>
      <div class="modal-content">
        <h2>Edit Specific ID: {{ newSpecific.specific_id }}</h2>

        <div class="add">
          <form @submit.prevent="updateSpecific">
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" class="form-control rounded" id="name" name="name" placeholder="Enter Specific Name"
                v-model="newSpecific.name" />
            </div>
            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
              <div v-if="errorMessage">{{ errorMessage }}</div>
            </div>
            <div>
              <button class="btn btn-primary rounded" type="submit">Update Specific</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>

import axios from 'axios';

export default {
  data() {
    return {
      allSpecifics: [],
      specifics: [],
      newSpecific: {
        name: '',
      },
      showAlert: false,
      errorMessage: '',
      processing: false,
      showTraineeList: false,
    };
  },
  methods: {

    async updateSpecific() {
      try {
        const specific_id = parseInt(localStorage.getItem('specific_id'));
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const normalizedNewSpecificName = this.newSpecific.name.trim().toLowerCase();
        // Check for duplicate Specific name, excluding the current Specific being updated
        const isNameDuplicate = this.allSpecifics.some(
          specific =>
            specific.name.trim().toLowerCase() === normalizedNewSpecificName &&
            specific.specific_id !== specific_id
        );
        if (isNameDuplicate) {
          console.error("Specific name already exists. Please choose a different name.");
          window.alert('Specific name already exists');
        } else {

        const response = await axios.put(
          `/api/specifics/${specific_id}`,
          {
            name: this.newSpecific.name,
          },
          { headers }
        );

        console.log('update')
        console.log(response);

        if (response.status === 200) {
          window.alert('Specific updated Successfully');
          this.specifics.push(response.data);
          this.newSpecific = {
            name: '',
          };
          this.errorMessage = '';
          this.showAlert = false;
          this.closeModalOutside();
        }
      }
      } catch (error) {
        console.error('Error adding Specific:', error);


        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = 'An error occurred while updating the Specific.';
        }

        this.showAlert = true;
      }
    },

    async fetchSpecifics() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.display('unauthorized');
          return;
        }

        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get('/api/specifics', { headers });
        if (response.status === 200) {
          this.allSpecifics = response.data;
        }
      } catch (error) {
        console.error('Error retrieving specifics:', error);
        // Handle error
      }
    },
    viewTraineeList() {
      this.showTraineeList = true; // Show the modal when the button is clicked
    },
    closeTraineeList() {
      this.showTraineeList = false; // Close the modal
    },
    goBack() {
      this.$router.push({ name: 'ViewSpecifics' });
    },
    closeModalOutside() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
    getSpecificData(specific_id) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        axios.get(`/api/specifics/${specific_id}`, { headers })
          .then(res => {
            this.newSpecific = res.data;
            console.log(res.data);
          });
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
  },
  async mounted() {
    this.fetchSpecifics();
    this.getSpecificData(localStorage.getItem('specific_id'));
  },
}
</script>
  
<style scoped>
.trainee-list-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Ensure the modal is on top of other content */
}

h2 {
  margin-top: 30px;
  font-size: 30px;
  margin-bottom: 30px;
}

/* Style your modal content */
.trainee-list-modal {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 1000px;
  /* Limit the maximum width of the modal */
  padding: 20px;
  position: relative;
  max-height: 95%;

}


.modal-content {
  overflow-y: auto;
  /* Enable scrolling within the modal content */
}


.add button {
  width: 200px;
  height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

input.form-control,
select.form-control {
  width: 70%;
  margin-left: 100px;
  display: inline-block;
  margin-bottom: 25px;
  align-items: baseline;
}

.form-group {
  margin-bottom: 15px;
}

label {
  margin-right: 5px;
  position: absolute;
  margin-top: 8px;
}

.form-control {
  border-radius: 5px;
}

.form-control#start_date {
  border-radius: 5px;
  width: 25%;
  margin-left: 100px;
  margin-right: 45%;
}

h1 {
  margin-bottom: 20px;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}
</style>
  